import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GoodStock  {
    _originalTypeClassName = "zERP.BO.GoodStock";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GoodStock.translate = translateService;
}
this.Transfers = [];
this.Id = null;
this.Availability = null;
this.Type = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Availability:any;
Type:any;
Warehouse:any;
Transfers:any;
Good:any;
static setWarehouse = ($this, value) => {
var oldValue = $this.Warehouse;
$this.Warehouse = value;
if (value != null) {
}
}
static setTransfers = ($this, items) => {
                if (items == null) items = [];
                if ($this.Transfers == null) $this.Transfers = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Transfers.length > 0) {
                    Domain.GoodStock.removeTransfers($this, $this.Transfers[0]);
                }

                Domain.GoodStock.addManyTransfers($this, copyItems);
            }
static addManyTransfers = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GoodStock.addTransfers($this, items[i]);
                }
            }
static addTransfers = ($this, item) => {
                if ($this.Transfers == null) $this.Transfers = [];
                if (item == null || $this.Transfers.indexOf(item) > -1) return;
                $this.Transfers.push(item);
if (item.Stock != $this) {
Domain.GoodTransfer.setStock(item, $this);
}
}
static addRangeTransfers = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GoodStock.addTransfers($this, item));
            }
static removeTransfers = ($this, item) => {
                if ($this == null || $this.Transfers == null || $this.Transfers.indexOf(item) === -1) return;
                var _index = $this.Transfers.indexOf(item);
                $this.Transfers.splice(_index, 1);
item.Stock = null;
}
static clearTransfers = ($this) => { $this.Transfers = null; }
static setGood = ($this, value) => {
var oldValue = $this.Good;
$this.Good = value;
if (value != null) {
if (oldValue != null) {
Domain.GoodBase.removeStock(oldValue, $this);
}
Domain.GoodBase.addStock(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}